import { render, staticRenderFns } from "./companyProfiles.vue?vue&type=template&id=0f143442&scoped=true"
import script from "./companyProfiles.vue?vue&type=script&lang=js"
export * from "./companyProfiles.vue?vue&type=script&lang=js"
import style0 from "./companyProfiles.vue?vue&type=style&index=0&id=0f143442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f143442",
  null
  
)

export default component.exports